import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const SnackBarExtListener = () => {
  const snackBar = useSelector((state: IReduxState) => state.webExtension.snackBar);

  useEffect(() => {
    if (snackBar?.messageMillis != 0 && snackBar?.message) {
      switch (snackBar.messageType) {
        case "error":
          toast.error(snackBar.message);
          break;
        case "success":
        default:
          toast.success(snackBar.message);
      }
    }
  }, [snackBar.message, snackBar?.messageMillis, snackBar.messageType]);

  return null;
};

export default SnackBarExtListener;
